import { jsx } from "react/jsx-runtime";
import { useOverflowDetector } from "@perxis-auto/shared";
import DealerDetails from "../DealerDetails/DealerDetails.js";
import Icon from "../Icon/Icon.js";
import classnames from "../../utils/classnames.js";
const DealerBalloonTags = ({ className, items }) => {
  const { ref: tagsRef, overflow: tagsOverflow } = useOverflowDetector();
  return /* @__PURE__ */ jsx(
    "div",
    {
      ref: tagsRef,
      className: classnames(
        [
          "perxis-auto-dealer-balloon-tags",
          {
            "perxis-auto-dealer-balloon-tags--overflow": tagsOverflow
          }
        ],
        className
      ),
      children: items.map((tag) => /* @__PURE__ */ jsx(
        DealerDetails,
        {
          tooltipTitle: tag.description,
          icon: !!tag.icon && /* @__PURE__ */ jsx(Icon, { name: tag.icon, sticker: "dealer-balloon-tag-icon" }),
          iconPosition: tag.iconPosition,
          iconColor: tag.iconColor,
          iconHoverColor: tag.iconHoverColor,
          color: tag.color,
          borderColor: tag.borderColor,
          borderHoverColor: tag.borderHoverColor,
          backgroundColor: tag.backgroundColor,
          children: tag.name,
          className: classnames("perxis-auto-dealer-balloon-tag")
        },
        tag.id
      ))
    }
  );
};
export {
  DealerBalloonTags as default
};
//# sourceMappingURL=DealerBalloonTags.js.map
